import { mapMutations, mapGetters, mapActions } from "vuex";
import { itemQuantity } from "../../../api/helpers/shoppingCartHelper.js";
import { $$ } from "./../../OO_jquery";
import uuid from "uuid/v1";
import { wcconfig } from "../../../../wcConfig.js";

export default {
  computed: {
    ...mapGetters([
      "cartItems",
      "applicableLoyalityRule",
      "useStampCollection"
    ]),
    isIos() {
      return !!navigator.platform.match(/iPhone|iPod|iPad/);
    },
    getStamps() {
      if (this.useStampCollection) return this.product.RewardPoint;
      else return null;
    },
    getPoints() {
      if (this.getStamps != null) return null;
      if (this.applicableLoyalityRule) {
        return Math.floor(
          this.totalPrice * this.applicableLoyalityRule.pointPerDollar
        );
      } else return null;
    },
    getBasePoints() {
      if (this.getStamps != null) return null;
      if (this.applicableLoyalityRule) {
        return Math.floor(
          this.price * this.applicableLoyalityRule.pointPerDollar
        );
      } else return null;
    },
    getRollIntoPoints() {
      if (this.getStamps != null) return null;
      if (this.applicableLoyalityRule) {
        if (this.selectedRollIntoModiefiers.length == 0)
          return Math.floor(
            this.showRollIntoProduct.FixedPriceValue *
              this.applicableLoyalityRule.pointPerDollar
          );
        else
          return Math.floor(
            this.rollIntoPrice * this.applicableLoyalityRule.pointPerDollar
          );
      } else return null;
    },
    totalPrice() {
      let sum = this.price || 0;
      var that = this;
      this.ModifierGroupsStates.filter(p => p.quantity > 0).forEach(state => {
        var modifier = that.modifiers[state.GroupId].Modifiers.filter(
          p => p.ID == state.MID
        )[0];
        sum += (this.computePrice(modifier) || 0) * state.quantity;
      });
      if (this.comboSelectedModifiers && this.comboSelectedModifiers.length > 0)
        this.comboSelectedModifiers.forEach(combo => {
          var modifier = combo.modifier;
          sum += (this.computePrice(modifier) || 0) * combo.modifier.quantity;
        });
      return sum * this.quantity + this.rollIntoPrice;
    },
    cartQuantity() {
      var item = { id: this.productId };
      const iq = itemQuantity(item, this.selectedModifiers, this.cartItems);
      return iq + this.quantity;
    },

    maxQuantity() {
      var item = { id: this.category.ProductID || this.productId };
      const iq = itemQuantity(item, this.getModifiers(), this.cartItems);
      return this.maxItemQuantity - iq;
    },
    createModifierObj(modifier) {
      return { md: modifier, count: 1 };
    },
    checkRule() {
      let modifierErrorMsgs = [];
      this.IsModifierRuleValided = true;
      for (var groupID of this.product.ModifierGroups) {
        var modifierOption = this.modifiers[groupID];
        if (!modifierOption) continue;
        if (modifierOption.Modifiers && modifierOption.Modifiers.length == 0)
          continue;
        let minSelection = modifierOption.MinimumSelection || 0;
        if (modifierOption.IsForceSel && minSelection) {
          var selectedItemInGroup = 0;
          this.ModifierGroupsStates.filter(
            p => p.GroupId == groupID && p.quantity > 0
          ).forEach(state => {
            selectedItemInGroup += state.quantity;
          });
          if (
            selectedItemInGroup < minSelection &&
            !modifierOption.IsSingleSel
          ) {
            this.IsModifierRuleValided = false;
            let msg =
              "Minimum selection of " +
              (modifierOption.Name || "Modifiers ") +
              " is " +
              minSelection;
            if (minSelection < 2) {
              modifierErrorMsgs.push(msg + " item.");
            } else {
              modifierErrorMsgs.push(msg + " items.");
            }
          }
        }
      }
      return modifierErrorMsgs;
    },
    isDisabledAddCards() {
      return (
        this.cartQuantity > this.maxItemQuantity ||
        !this.IsModifierRuleValided ||
        this.toggleRollInto
      );
    }
  },
  methods: {
    ...mapMutations(["Add_ProductItem"]),
    ...mapActions(["applyPriceTriggers"]),
    fixQuantity(group, checked, md, groupID) {
      if (md && group) {
        if (checked) {
          if (group.IsSingleSel) {
            group.Modifiers.forEach(function(item) {
              item.quantity = 0;
              item.IsSelected = false;
            });
            this.ModifierGroupsStates.filter(p => p.GroupId == groupID).forEach(
              state => {
                (state.quantity = 0), (state.IsSelected = false);
              }
            );
          }
          if (!md.quantity || md.quantity == 0) {
            md.quantity = 1;
            md.IsSelected = true;
          }
        } else {
          md.quantity = 0;
          md.IsSelected = false;
        }
        var state = this.ModifierGroupsStates.filter(
          p => p.GroupId == groupID && p.MID == md.ID
        )[0];
        if (state) {
          (state.quantity = md.quantity), (state.IsSelected = md.IsSelected);
        } else {
          state = {
            GroupId: groupID,
            MID: md.ID,
            quantity: md.quantity,
            IsSelected: md.IsSelected
          };
          this.ModifierGroupsStates.push(state);
        }
      }
      this.$forceUpdate();
    },
    closeModal() {
      this.$parent.closeModal();
    },
    closeModalMobile() {
      this.$nextTick(() => {
        this.$parent.closeModal();
        const bodyScrollLock = require("body-scroll-lock");
        const targetElement = $$(".extra-items-wrapper");
        bodyScrollLock.enableBodyScroll(targetElement[0]);
      });
    },
    distinct(value) {
      let unique = {};
      value.forEach(function(x) {
        if (!unique[x.ID]) {
          //strict
          Object.defineProperty(unique, x.ID, { value: x, enumerable: true });
        }
      });

      return Object.values(unique);
    },
    inc() {
      this.quantity++;
    },
    dec() {
      this.quantity--;
    },
    getModifiers() {
      var selectedModifiers = [];
      this.ModifierGroupsStates.filter(p => p.quantity > 0).forEach(state => {
        var that = this;
        selectedModifiers.push({
          ...that.modifiers[state.GroupId].Modifiers.find(
            p => p.ID == state.MID
          ),
          quantity: state.quantity
        });
      });
      if (
        this.comboSelectedModifiers &&
        this.comboSelectedModifiers.length > 0
      ) {
        this.comboSelectedModifiers.forEach(combo => {
          selectedModifiers.push({
            ...combo.modifier
          });
        });
      }
      return selectedModifiers;
    },
    addToCart() {
      this.Add_ProductItem({
        item: {
          id: this.category.ProductID,
          uniqueId: uuid(),
          itemNote: this.itemNote,
          code: this.product.ProductCode,
          name: this.category.Name,
          description: this.product.ShortDescription,
          photoUrl: this.product.PhotoUrl,
          tax: this.product.TaxRate,
          RewardPoint: this.product.RewardPoint,
          price: this.price,
          categoryId: this.parentCategory.ID,
          categoryName: this.parentCategory.Name
        },
        quantity: this.quantity,
        ProductCategoryIDs: this.product.ProductCategoryIDs,
        ProductTagIDs: this.product.ProductTagIDs,
        modifiers: this.getModifiers()
      });
      this.applyPriceTriggers();
      if (this.selectedRollIntoModiefiers.length > 0) {
        this.confirmRollInto({
          id: this.showRollIntoProduct.ID,
          modifiers: this.selectedRollIntoModiefiers
        });
      }
      this.applyPriceTriggers();
    },
    addToCartMobile() {
      this.Add_ProductItem({
        item: {
          id: this.category.ProductID,
          uniqueId: uuid(),
          code: this.product.ProductCode,
          name: this.product.Name,
          description: this.product.ShortDescription,
          photoUrl: this.product.PhotoUrl,
          tax: this.product.TaxRate,
          RewardPoint: this.product.RewardPoint,
          price: this.price,
          categoryId: this.parentCategory.ID,
          categoryName: this.parentCategory.Name
        },
        quantity: this.quantity,
        ProductCategoryIDs: this.product.ProductCategoryIDs,
        ProductTagIDs: this.product.ProductTagIDs,
        modifiers: this.getModifiers()
      });
      this.$nextTick(() => {
        this.$parent.closeModal();
        const bodyScrollLock = require("body-scroll-lock");
        const targetElement = $$(".extra-items-wrapper");
        bodyScrollLock.enableBodyScroll(targetElement[0]);
      });
      this.applyPriceTriggers();
      if (this.selectedRollIntoModiefiers.length > 0) {
        this.confirmRollInto({
          id: this.showRollIntoProduct.ID,
          modifiers: this.selectedRollIntoModiefiers
        });
      }
      this.applyPriceTriggers();
    },
    imgHttpError() {
      this.$refs.headerImg.style.display = "none";
    },
    getSelectedValue(groupID, MId) {
      var state = this.ModifierGroupsStates.filter(
        p => p.GroupId == groupID && p.MID == MId
      )[0];
      if (state) return state.IsSelected;
      else return false;
    },

    selectRollIntoModiefiers(modifiers) {
      if (this.selectedModifierForCustomize) {
        this.$set(
          this.selectedModifierForCustomize,
          "selectedSubmodifiers",
          modifiers
        );
        // this.selectedModifierForCustomize.selectedSubmodifiers = modifiers;
        this.selectedModifierForCustomize = null;
      } else this.selectedRollIntoModiefiers = modifiers;
      this.toggleRollInto = false;
    },
    getImageStyle() {
      if (this.viewConfig.ImageCenterMode) {
        return {
          "background-image": "url(" + this.getProductImage(this.product) + ")",
          "background-size": "contain",
          "background-repeat": "no-repeat",
          "background-position": "center",
          "background-position-x": "center"
        };
      } else {
        return {
          "background-image": "url(" + this.getProductImage(this.product) + ")"
        };
      }
    },
    getProductImage(product) {
      if (product.PhotoUrl) return product.PhotoUrl;
      else return wcconfig.assets.productDefaultImg;
    },
    customizeSubmodifier(modifier) {
      this.selectedModifierForCustomize = modifier;
      this.toggleRollInto = true;
      if (this.isIos)
        this.$nextTick(() => {
          const bodyScrollLock = require("body-scroll-lock");
          const targetElement = $$(".submodifier-scroll");
          for (var i = 0; i < targetElement.length; i++) {
            bodyScrollLock.disableBodyScroll(targetElement[i]);
          }
        });
    },
    computePrice(modifier) {
      var sum = modifier.Price;
      if (modifier.selectedSubmodifiers) {
        modifier.selectedSubmodifiers.forEach(element => {
          sum += element.Price * element.quantity;
        });
      }
      return sum;
    },
    isComboItem(groupsId) {
      for (var groupId of groupsId) {
        for (var modifier of this.modifiers[groupId].Modifiers) {
          if (modifier.LinkedProductID) {
            return true;
          }
        }
      }
      return false;
    }
  }
};
